import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import ReactDom from "react-dom/client";
import "./index.scss"

function getRoot() {
  let root;
  if (document.body.querySelector(".message__box")) {
    root = document.body.querySelector(".message__box") 
  } else {
    root = document.createElement("div");
    root.className = "message__box";
    document.body.appendChild(root);
  }
  return root;
}

let onCloseHandler;

const Message = ({ type, content, closeTime = 1000, container, root }) => {
  const myRef = useRef(null);
  const closedRef = useRef(false);
  const [hide, setHide] = useState(false);

  const close = () => {
    if (closedRef.current) {
      return;
    }
    closedRef.current = true;

    if (myRef.current) {
      setHide(true);

      setTimeout(() => {
        const box = container?.parentNode;
        root?.unmount();

        if (box && container?.parentNode === box) {
          box.removeChild(container);
        }

        if (box?.childNodes.length === 0 && box.parentNode === window.document.body) {
          window.document.body.removeChild(box);
        }
      }, 1000);
    }
  };

  useEffect(() => {
    onCloseHandler = close;
    const timer = setTimeout(close, closeTime);
    return () => clearTimeout(timer);
  }, [closeTime]);

  const mergeClassName = classnames("message", `message--${type}`, {
    "message--hide": hide,
  });

  return (
    <div className={mergeClassName} ref={myRef}>
      <div className="message__icon" ></div>
      <div className="message__content">{content}</div>
    </div>
  );
};

function getComponent({ ...props }) {
  const container = document.createElement("div");
  getRoot().appendChild(container);
  const root = ReactDom.createRoot(container);

  root.render(<Message {...props} container={container} root={root} />);
}

export const message = {
  show({ ...props }) {
    return getComponent(props);
  },
  close() {
    onCloseHandler && onCloseHandler();
  },
};
